"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6307],{

/***/ 822855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(672651);
/* harmony import */ var _lazyPayAuth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(514456);





var LazyPayAuthModal = function(props) {
    var lazyPayAuthModal = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            lazyPayAuthModal: state.commonReducer.lazyPayAuthModal
        };
    }).lazyPayAuthModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        visible: lazyPayAuthModal.show,
        className: "bottom-modal",
        animation: "slideUp",
        onClose: props.onClose,
        height: "auto",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lazyPayAuth__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            onClose: props.onClose
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LazyPayAuthModal);


/***/ }),

/***/ 22084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ PaymentOrPlaceOrderCTA; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(452388);
// EXTERNAL MODULE: ./src/utils/isStoreServiceBased.js
var isStoreServiceBased = __webpack_require__(666466);
;// CONCATENATED MODULE: ./src/components/PaymentModal/components/CommonCTA/index.js

var CommonCTA = function(param) {
    var text = param.text, onClick = param.onClick, bgColor = param.bgColor, borderRadius = param.borderRadius, isDisable = param.isDisable;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "w-100 white bn f16px fw6 shadow-4 tw-p-3",
        style: {
            backgroundColor: bgColor,
            borderRadius: borderRadius
        },
        onClick: onClick,
        disabled: isDisable,
        children: text
    });
};
/* harmony default export */ var components_CommonCTA = (CommonCTA);

;// CONCATENATED MODULE: ./src/components/PaymentModal/components/PlaceOrderButton/index.js





var PlaceOrderButton = function(param) {
    var onClick = param.onClick;
    var ref;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return {
            theme: state.storeReducer.store.theme,
            loader: state.commonReducer.loader
        };
    }), theme = ref1.theme, loader = ref1.loader;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CommonCTA, {
        text: (0,isStoreServiceBased/* isStoreServiceBased */.A)() ? "Confirm Booking" : "Place Order",
        bgColor: (theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color) || "#EA5151",
        borderRadius: theme ? "".concat((0,util/* roundnessCalculator */.M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px",
        onClick: onClick,
        isDisable: loader
    });
};
/* harmony default export */ var components_PlaceOrderButton = (PlaceOrderButton);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./src/utils/getPaymentMethodName.js
var getPaymentMethodName = __webpack_require__(494604);
;// CONCATENATED MODULE: ./src/components/PaymentModal/components/ProceedToPayButton/index.js






var ProceedToPayButton = function(param) {
    var paymentData = param.paymentData, onClick = param.onClick;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            theme: state.storeReducer.store.theme,
            loader: state.commonReducer.loader
        };
    }), theme = ref.theme, loader = ref.loader;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CommonCTA, {
        text: "Pay using " + (0,getPaymentMethodName/* getPaymentMethodName */.d)(paymentData.selectedPaymentMethod.payment_option_name || paymentData.method),
        bgColor: "#2b74d8",
        borderRadius: theme ? "".concat((0,util/* roundnessCalculator */.M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px",
        onClick: function() {
            return onClick.apply(void 0, (0,_to_consumable_array/* default */.Z)(Object.values(paymentData)));
        },
        isDisable: loader
    });
};
/* harmony default export */ var components_ProceedToPayButton = (ProceedToPayButton);

;// CONCATENATED MODULE: ./src/components/PaymentModal/components/PaymentOrPlaceOrderCTA/index.js



var PaymentOrPlaceOrderCTA = function(param) {
    var state = param.state, onProceedToPay = param.onProceedToPay, onPlaceOrder = param.onPlaceOrder, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    if (!(state.payOnDelivery || state.selectedPaymentData)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: customClasses || "fixed bottom-0 left-0 right-0 w-100 pa20px bg-white shadow-3 z-999",
        children: [
            !!state.selectedPaymentData && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProceedToPayButton, {
                paymentData: state.selectedPaymentData,
                onClick: onProceedToPay
            }),
            !!state.payOnDelivery && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PlaceOrderButton, {
                onClick: onPlaceOrder
            })
        ]
    });
};


/***/ }),

/***/ 928721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(336623);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(913886);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(326706);




var SelectCashOnDelivery = function(param) {
    var isSelectedCOD = param.isSelectedCOD, toggleCOD = param.toggleCOD, codCharge = param.codCharge, ctaType = param.ctaType, _unselectablePaymentOptions = param.unselectablePaymentOptions, unselectablePaymentOptions = _unselectablePaymentOptions === void 0 ? [] : _unselectablePaymentOptions;
    var ref;
    var storeInfo = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_3__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var isCodDisabledDueToCoupon = unselectablePaymentOptions === null || unselectablePaymentOptions === void 0 ? void 0 : unselectablePaymentOptions.includes(_utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .PAYMENT_TYPE_CONSTANTS.COD */ .Mf.COD);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pt2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "fw6 black-40",
                children: "OR"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "shadow-4 pa3 br3 ".concat(isCodDisabledDueToCoupon ? "tw-cursor-not-allowed tw-opacity-40" : ""),
                onClick: !isCodDisabledDueToCoupon && toggleCOD,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "radio",
                        checked: isSelectedCOD,
                        disabled: isCodDisabledDueToCoupon
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "ml2",
                        children: (0,_utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ctaType)
                    }),
                    (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.cod_charge_flag) > _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .COD_CHARGE_TYPE.FREE */ .VV.FREE && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "extra-cod-charges",
                        style: {
                            marginTop: "4px",
                            marginLeft: "21px"
                        },
                        children: "Extra delivery fees ₹ ".concat(codCharge)
                    })
                ]
            }),
            isCodDisabledDueToCoupon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "tw-m-0 tw-pt-[8px] tw-text-[11px]/[15px] tw-text-[#111C36CC] ",
                children: "You cannot select this option, the applied offer is not applicable on ‘Pay on Delivery’ orders."
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectCashOnDelivery);


/***/ }),

/***/ 559400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TotalAmountSaved; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./src/assets/svgExports/GreatIcon.js

var GreatIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        id: "greatIcon",
        width: "9",
        height: "14",
        viewBox: "0 0 9 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.0448 14H6.45968C6.68576 14 6.8687 13.8166 6.8687 13.5898V13.1475C6.86911 12.5123 7.18863 11.8713 7.74626 11.4363C8.50799 10.8427 8.91222 10.2783 8.98292 9.71116C9.05761 9.10995 8.84312 8.74904 8.6502 8.55239C8.51585 8.4157 8.22329 8.32243 7.96618 8.43177C7.78733 8.50779 7.65423 8.66337 7.60638 8.85218C7.34177 9.89639 6.44825 10.6641 5.31696 10.6641C3.96157 10.6641 2.86284 9.56227 2.86284 8.20312C2.86284 6.84398 3.96157 5.74219 5.31696 5.74219C6.08152 5.74219 6.76047 6.09457 7.20837 6.64511C7.41629 6.90066 7.76189 6.99743 8.07176 6.88693C8.38158 6.77644 8.58904 6.48249 8.58912 6.15234C8.58912 4.7116 6.24843 4.10156 5.31696 4.10156C4.2261 4.10156 3.19957 4.52854 2.42587 5.304C1.01777 6.71677 1.26158 8.41228 1.23196 8.58725C1.22596 9.77927 1.21797 11.4662 1.64297 13.6668C1.6797 13.8602 1.84866 14 2.0448 14Z",
                fill: "#0E0E0E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.74777 3.50666C7.48322 2.84871 7.22215 3.10085 7.61994 2.77075C7.97014 2.49177 8.03591 1.97617 7.75134 1.6172C7.47853 1.27355 6.94328 1.21344 6.60298 1.48582C6.4169 1.64703 5.72478 2.11212 4.62305 3.33557C4.85142 3.30316 5.08219 3.28104 5.31683 3.28104C5.71543 3.28104 6.2251 3.3558 6.74777 3.50666Z",
                fill: "#0E0E0E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.45597 0.0840805C4.06214 -0.116212 3.55406 0.0552329 3.35795 0.450979C3.22163 0.775467 2.40635 2.03292 1.89551 4.67983C2.28162 4.30292 2.71919 4.00006 3.19087 3.77169C3.52545 3.35158 3.86161 2.95463 4.20129 2.58918C4.57972 1.58812 4.65195 1.55006 4.82186 1.18316C5.02737 0.769342 4.85068 0.281147 4.45597 0.0840805Z",
                fill: "#0E0E0E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.854387 6.18259C0.987509 4.83194 1.25842 3.52518 1.67641 2.30182C1.65203 1.9451 1.63106 1.58804 1.64096 1.22968L1.65135 0.843145C1.66408 0.406055 1.33002 0.0125781 0.832927 0C0.38595 0 0.0272666 0.350875 0.0160867 0.798273L0.0056975 1.18519C-0.0411489 2.88654 0.202518 4.91189 0.676654 6.65591C0.728163 6.49351 0.787389 6.33574 0.854387 6.18259Z",
                fill: "#0E0E0E"
            })
        ]
    });
};
/* harmony default export */ var svgExports_GreatIcon = (GreatIcon);

;// CONCATENATED MODULE: ./src/components/PaymentModal/components/TotalAmountSaved/index.js


var TotalAmountSaved = function(param) {
    var amount = param.amount;
    return !!amount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        class: "flex items-center justify-center pv6px ph12px br3 mb3 tw-w-max tw-bg-[#cdffe4]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_GreatIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                class: "f13px fw5 ml8px tw-text-xs",
                children: [
                    "Great! You’re saving ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        class: "fw7",
                        children: [
                            "₹ ",
                            amount
                        ]
                    }),
                    " on this order!"
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TotalAmountSaved = (TotalAmountSaved);


/***/ }),

/***/ 716307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PaymentModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(672651);
// EXTERNAL MODULE: ./src/components/PaymentOptions/index.js
var PaymentOptions = __webpack_require__(68102);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(467936);
// EXTERNAL MODULE: ./src/redux/actions/payment.js
var payment = __webpack_require__(119372);
// EXTERNAL MODULE: ./src/redux/actions/order.js
var order = __webpack_require__(804160);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/codMethodRender.js
var codMethodRender = __webpack_require__(642490);
// EXTERNAL MODULE: ./src/utils/deviceInfo.js
var deviceInfo = __webpack_require__(990864);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/components/LazyPayAuth/index.js
var LazyPayAuth = __webpack_require__(822855);
// EXTERNAL MODULE: ./src/components/DesktopPaymentModal/index.js + 3 modules
var DesktopPaymentModal = __webpack_require__(757909);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/components/PaymentModal/components/TotalAmountSaved/index.js + 1 modules
var TotalAmountSaved = __webpack_require__(559400);
// EXTERNAL MODULE: ./src/components/CustomRadio/index.js
var CustomRadio = __webpack_require__(143388);
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var index_es = __webpack_require__(924762);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
;// CONCATENATED MODULE: ./src/components/PaymentModal/components/SelectPartialPaymentType/index.js







var SelectPartialOrFullPayment = function(param) {
    var selectedType = param.selectedType, setSelectedType = param.setSelectedType;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            partial_payment_amount: state.paymentReducer.partial_payment_amount,
            orderDetails: state.orderReducer.orderDetails,
            paymentModalOptionsVisibility: state.commonReducer.paymentModalOptionsVisibility
        };
    }), partial_payment_amount = ref.partial_payment_amount, orderDetails = ref.orderDetails, paymentModalOptionsVisibility = ref.paymentModalOptionsVisibility;
    var storeInfo = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var isPartialPaymentToggleNotAllowed = partial_payment_amount < constants/* MINIMUM_ORDER_AMOUNT */.BI || partial_payment_amount >= orderDetails.buyer_pay_value;
    var isFullPayment = selectedType === constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "partial-payment-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "title",
                        children: "Select a payment method"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "radio-input-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "radio-input-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadio/* default */.Z, {
                                        type: "radio",
                                        checked: isFullPayment,
                                        "aria-checked": isFullPayment,
                                        onClick: function() {
                                            return setSelectedType(constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "radio-content-wrap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                            className: "fw5",
                                            children: "Full Payment"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "radio-input-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadio/* default */.Z, {
                                        type: "radio",
                                        checked: !isFullPayment,
                                        "aria-checked": !isFullPayment,
                                        className: isPartialPaymentToggleNotAllowed ? "tw-cursor-not-allowed" : "tw-cursor-pointer",
                                        onClick: function() {
                                            return setSelectedType(constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT);
                                        },
                                        disabled: isPartialPaymentToggleNotAllowed
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "radio-content-wrap mobile-radio-wrap",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                                className: "",
                                                children: [
                                                    storeInfo.services.partial_payment_flag === constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT ? "".concat(storeInfo.services.partial_payment_value, "% ") : "",
                                                    "Partial Payment - Rs. ",
                                                    partial_payment_amount
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                loading: "lazy",
                                                src: "/assets/icons/tooltipGrayIcon.svg",
                                                "data-tip": true,
                                                "data-for": "partial-payment-info"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                                id: "partial-payment-info",
                                                place: "bottom",
                                                effect: "solid",
                                                multiline: true,
                                                padding: "8px",
                                                disable: false,
                                                arrowColor: "#4F4F4F",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mv0 fw5 f12px",
                                                    children: "Choose this option to make a partial payment. The remaining amount will be collected at the time of delivery/pickup."
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalAmountSaved/* default */.Z, {
                amount: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.amount_saved
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "f4 fw6 pv3 ".concat(!paymentModalOptionsVisibility ? "dn" : ""),
                style: {
                    paddingTop: "0px"
                },
                children: [
                    "Pay ₹",
                    orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value
                ]
            })
        ]
    });
};
/* harmony default export */ var SelectPartialPaymentType = (SelectPartialOrFullPayment);

// EXTERNAL MODULE: ./src/components/PaymentModal/components/SelectCashOnDelivery/index.js
var SelectCashOnDelivery = __webpack_require__(928721);
// EXTERNAL MODULE: ./src/components/PaymentModal/components/PaymentOrPlaceOrderCTA/index.js + 3 modules
var PaymentOrPlaceOrderCTA = __webpack_require__(22084);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader.tsx
var GlobalCfeLoader = __webpack_require__(179220);
// EXTERNAL MODULE: ./src/hooks/useUnselectablePaymentOptions.tsx
var useUnselectablePaymentOptions = __webpack_require__(908623);
// EXTERNAL MODULE: ./src/utils/canDisablePlaceOrder.ts
var canDisablePlaceOrder = __webpack_require__(596930);
;// CONCATENATED MODULE: ./src/components/PaymentModal/index.js
/**
 * Payment Modal
 * Component
 */ 


























var PaymentModal = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref6.widgetContextState.globalStyle;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref7 = (0,react.useState)({
        payOnDelivery: false,
        selectedPaymentData: null
    }), state = ref7[0], setState = ref7[1];
    var partialPaymentFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().partialPaymentFeatureStatus;
    var partialPaymentFeatureVisible = partialPaymentFeatureStatus === null || partialPaymentFeatureStatus === void 0 ? void 0 : partialPaymentFeatureStatus.isVisible;
    var ref8 = (0,react.useState)(0), codCharge = ref8[0], setCodCharge = ref8[1];
    var ref9 = (0,react.useState)(constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT), selectedPartialPaymentMode = ref9[0], setSelectedPartialPaymentMode = ref9[1];
    var ref10 = (0,es/* useSelector */.v9)(function(state) {
        return {
            paymentModalVisibility: state.commonReducer.paymentModalVisibility,
            orderDetails: state.orderReducer.orderDetails,
            storeInfo: state.storeReducer.store,
            loader: state.commonReducer.loader,
            cart: state.cartReducer,
            otherMethods: state.paymentReducer.otherMethods,
            paymentOptionsWithTxnCharge: state.paymentReducer.paymentOptionsWithTxnCharge,
            userData: state.userReducer.data,
            partial_payment_amount: state.paymentReducer.partial_payment_amount,
            paymentModalOptionsVisibility: state.commonReducer.paymentModalOptionsVisibility
        };
    }), paymentModalVisibility = ref10.paymentModalVisibility, orderDetails = ref10.orderDetails, storeInfo = ref10.storeInfo, loader = ref10.loader, cart = ref10.cart, otherMethods = ref10.otherMethods, paymentOptionsWithTxnCharge = ref10.paymentOptionsWithTxnCharge, userData = ref10.userData, paymentModalOptionsVisibility = ref10.paymentModalOptionsVisibility;
    var finalUnselectablePaymentOptions = (0,useUnselectablePaymentOptions/* default */.Z)().finalUnselectablePaymentOptions;
    var isPartialPaymentEnabled = partialPaymentFeatureVisible && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.partial_payment_flag) && orderDetails.prepaid_flag > 0;
    var isChildOrder = orderDetails.parent_order_id !== 0 && orderDetails.partial_payment_type > 0;
    var showPartialPayment = isPartialPaymentEnabled && !isChildOrder;
    (0,react.useEffect)(function() {
        setCodCharge((0,DesktopPaymentModal/* _getCODCharges */.__)(orderDetails, storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.services));
        dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(true));
        if (paymentModalVisibility) {
            var ref;
            var paymentMethod = (ref = cart.payment_offer) === null || ref === void 0 ? void 0 : ref.payment_method;
            if (paymentMethod && paymentMethod !== constants/* PAYMENT_TYPE_CONSTANTS.LAZYPAY */.Mf.LAZYPAY) {
                var isCardTypeMethod = paymentMethod === constants/* PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */.Mf.DEBIT_CARD || paymentMethod === constants/* PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */.Mf.CREDIT_CARD;
                var finalPaymentMethod = isCardTypeMethod ? constants/* PAYMENT_TYPE_CONSTANTS.CARD */.Mf.CARD : paymentMethod;
                debouncedSubmitPayment(finalPaymentMethod, true);
            } else {
                document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            }
        } else {
            document.getElementsByTagName("body")[0].style.overflowY = "scroll";
        }
        clearSelectedPaymentMode();
    }, [
        paymentModalVisibility
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (paymentModalVisibility && !(cart === null || cart === void 0 ? void 0 : (ref = cart.payment_offer) === null || ref === void 0 ? void 0 : ref.payment_method)) {
            var ref1;
            dispatch((0,logs/* pushEventsLog */.U)({
                event_name: "Cx_Payment_Init",
                data: {
                    store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                    domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain,
                    device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                    cx_number: userData === null || userData === void 0 ? void 0 : userData.phone
                }
            }));
        }
    }, [
        paymentModalVisibility,
        cart === null || cart === void 0 ? void 0 : (ref1 = cart.payment_offer) === null || ref1 === void 0 ? void 0 : ref1.payment_method
    ]);
    var submitPayment = function(method) {
        var isPaymentPromoPresent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, selectedPaymentMethod = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, orderHash = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash;
        if (loader) {
            (0,Toast/* toastNotifyInfo */.lU)("Payment initiation in progress.");
            return;
        }
        /**
     * if payment method is emi
     * reroute to /emi-payment page for emi payment
     * through card
     */ if (method === constants/* PAYMENT_TYPE_CONSTANTS.EMI */.Mf.EMI) {
            var ref;
            router.push({
                pathname: (0,routes.getRoute)(routes.PATH.EMI_PAYMENT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain),
                query: {
                    emiPrice: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value
                }
            });
        } else {
            var ref1;
            var payload = {
                orderID: orderHash,
                paymentMethod: method,
                merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
                deviceType: (0,deviceInfo/* getDeviceInfo */.d)().OSName,
                browserType: (0,deviceInfo/* getDeviceInfo */.d)().BrowserName,
                userAgent: (0,deviceInfo/* getDeviceInfo */.d)().userAgent,
                source: "longtail",
                merchantName: "Digital Showroom - ".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.name),
                phone: userData === null || userData === void 0 ? void 0 : userData.phone
            };
            dispatch((0,payment/* savePaymentInfo */.YI)(payload));
            if (isPaymentPromoPresent) {
                var ref2;
                payload["promoCode"] = cart === null || cart === void 0 ? void 0 : (ref2 = cart.payment_offer) === null || ref2 === void 0 ? void 0 : ref2.promo_code;
            }
            if (method === constants/* PAYMENT_TYPE_CONSTANTS.LAZYPAY */.Mf.LAZYPAY) {
                var ref3;
                payload.phone = orderDetails.phone;
                payload.amount = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.services) === null || ref3 === void 0 ? void 0 : ref3.mdr_flag) ? selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.pay_amount : orderDetails.amount;
                payload.store_id = orderDetails.store_id;
                dispatch((0,payment/* initLazyPayPayment */.q)(payload));
            } else {
                dispatch((0,payment/* initPayment */.yK)(payload, router));
            }
        }
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("orderID", orderHash);
    };
    var onSelectPaymentMode = function(method) {
        var isPaymentPromoPresent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, selectedPaymentMethod = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, orderHash = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash;
        state.payOnDelivery && togglePayOnDeliveryCheckbox();
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selectedPaymentData: {
                    method: method,
                    isPaymentPromoPresent: isPaymentPromoPresent,
                    selectedPaymentMethod: selectedPaymentMethod,
                    orderHash: orderHash
                }
            });
        });
    };
    var debouncedSubmitPayment = debounce_default()(submitPayment, 1500, {
        leading: true,
        trailing: false
    });
    var onClose = function() {
        setSelectedPartialPaymentMode(constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT);
        dispatch((0,common/* setPaymentModalVisiblity */.Tc)(false));
        dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(true));
    };
    var clearSelectedPaymentMode = function() {
        state.selectedPaymentData && setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selectedPaymentData: null
            });
        });
    };
    var togglePayOnDeliveryCheckbox = function() {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                payOnDelivery: !state.payOnDelivery
            });
        });
        clearSelectedPaymentMode();
    };
    var onPlaceOrderBtnClick = function() {
        if ((0,canDisablePlaceOrder/* canDisablePlaceOrder */.w)()) {
            return;
        }
        dispatch((0,order/* updateOrderState */.oW)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash, router));
    };
    var onCloseLazyPayAuthModal = function() {
        dispatch((0,common/* toggleLazyPayAuthModal */.zk)({
            show: false
        }));
    };
    var handleInputRadioClick = function(type) {
        // if user is clicking same input radio again n again, don't allow any network call.
        if (type === selectedPartialPaymentMode) return;
        dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(false));
        var payload = {
            store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
            order_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id,
            part_payment_option: type,
            pay_amount: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.pay_amount
        };
        dispatch((0,payment/* togglePartialPaymentMode */.bj)(payload, function() {
            dispatch((0,payment/* fetchPaymentMethods */.F7)({
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash
            }));
            dispatch((0,order/* fetchOrderByHash */.yZ)({
                order_hash: orderDetails.order_hash,
                isPrepaid: 1
            }));
            dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(true));
            setSelectedPartialPaymentMode(type);
        }));
    };
    var renderUnselectablePaymentOption = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: finalUnselectablePaymentOptions.map(function(paymentOption) {
                switch(paymentOption){
                    case constants/* PAYMENT_TYPE_CONSTANTS.COD */.Mf.COD:
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectCashOnDelivery/* default */.Z, {
                                isSelectedCOD: state.payOnDelivery,
                                toggleCOD: togglePayOnDeliveryCheckbox,
                                codCharge: codCharge,
                                ctaType: "cart_confirm_cta",
                                unselectablePaymentOptions: finalUnselectablePaymentOptions
                            });
                        }
                    default:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                }
            })
        });
    };
    return paymentModalVisibility && !(cart === null || cart === void 0 ? void 0 : (ref2 = cart.payment_offer) === null || ref2 === void 0 ? void 0 : ref2.payment_method) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                visible: paymentModalVisibility,
                className: "bottom-modal cartValidationErrorMsgModal",
                animation: "slideUp",
                onClose: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedPaymentData || state.payOnDelivery ? "tw-pb-[5.0625rem]" : "",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "closeicon",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                loading: "lazy",
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                                alt: "cancel"
                            })
                        }),
                        showPartialPayment ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPartialPaymentType, {
                            selectedType: selectedPartialPaymentMode,
                            setSelectedType: handleInputRadioClick
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalAmountSaved/* default */.Z, {
                                    amount: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.amount_saved
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "f4 fw6 pv3",
                                    children: [
                                        "Pay ₹",
                                        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "f6 fw6 pv3 o-50",
                                    children: "Choose a Payment Method"
                                })
                            ]
                        }),
                        !paymentModalOptionsVisibility ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center items-center bg-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                                type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref3 = globalStyle.appLoader) === null || ref3 === void 0 ? void 0 : ref3.loaderId) || "ellipsis",
                                color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref4 = globalStyle.appLoader) === null || ref4 === void 0 ? void 0 : ref4.color
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOptions/* default */.Z, {
                                    onSelect: onSelectPaymentMode
                                }),
                                ((ref5 = (0,codMethodRender/* codMethodRender */.a)(otherMethods, paymentOptionsWithTxnCharge, storeInfo)) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectCashOnDelivery/* default */.Z, {
                                    isSelectedCOD: state.payOnDelivery,
                                    toggleCOD: togglePayOnDeliveryCheckbox,
                                    codCharge: codCharge,
                                    ctaType: "cart_confirm_cta"
                                }),
                                renderUnselectablePaymentOption()
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOrPlaceOrderCTA/* PaymentOrPlaceOrderCTA */.G, {
                state: state,
                onProceedToPay: debouncedSubmitPayment,
                onPlaceOrder: onPlaceOrderBtnClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyPayAuth/* default */.Z, {
                onClose: onCloseLazyPayAuthModal
            })
        ]
    });
};
/* harmony default export */ var components_PaymentModal = (PaymentModal);


/***/ }),

/***/ 68102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _utils_getPrepaidInvalidAmountMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37202);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66871);
/* harmony import */ var _utils_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(631891);
/* harmony import */ var _utils_getPaymentMethodName__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(494604);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(186812);
/* harmony import */ var _utils_operatingSystem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(755311);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(225617);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(119372);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(913886);
/* harmony import */ var _Common_Toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40804);
/* harmony import */ var _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(506337);














var PaymentOptionsGrid = function(param) {
    var onSelect = param.onSelect;
    var ref;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return {
            store: state.storeReducer.store,
            orderDetails: state.orderReducer.orderDetails,
            methods: state.paymentReducer.methods,
            downPaymentMethods: state.paymentReducer.downPaymentMethods,
            paymentOptionsWithTxnCharge: state.paymentReducer.paymentOptionsWithTxnCharge
        };
    }), store = ref1.store, orderDetails = ref1.orderDetails, methods = ref1.methods, downPaymentMethods = ref1.downPaymentMethods, paymentOptionsWithTxnCharge = ref1.paymentOptionsWithTxnCharge;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (store === null || store === void 0 ? void 0 : store.store_id) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash) && dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .fetchPaymentMethods */ .F7)({
            store_id: store === null || store === void 0 ? void 0 : store.store_id,
            hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash
        }));
    }, [
        store,
        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash
    ]);
    var tapOptionForCustomerPayment = function(option, item) {
        /*
      MDR and EMI options are exclusive now.
      So if EMI option is selected then, 
      prePaymentCheckMDRTransactions is now not required.

      if emi payment method selected, then we can avoid using the 
      prePaymentCheckMDRTransactions api.

      Here we can go directly to initPayment for payment using emi
    */ // if (option === PAYMENT_TYPE_CONSTANTS.EMI) {
        //   onTapOption(option, item);
        //   return;
        // }
        if (item && (0,_utils_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_11__/* .checkIfObjectExists */ .L)(item)) {
            var payload = {
                order_hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                store_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.store_id,
                payment_option: item
            };
            var callback = function(isTrue) {
                if (isTrue) {
                    onTapOption(option, item);
                    return;
                }
                return;
            };
            (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .batch */ .dC)(function() {
                dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .setCustomerTransactionPaymentMethod */ .j1)(item));
                dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .prePaymentCheckMDRTransactions */ .HV)(payload, callback));
            });
        }
    };
    var onTapOption = function(option) {
        var selectedPaymentMethod = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value) < _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .MINIMUM_ORDER_AMOUNT */ .BI) {
            (0,_Common_Toast__WEBPACK_IMPORTED_MODULE_8__/* .toastNotifyError */ .Lu)((0,_utils_getPrepaidInvalidAmountMessage__WEBPACK_IMPORTED_MODULE_2__/* .getPrepaidInvalidAmountMessage */ .a)((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_3__/* .getStoreType */ .K)()));
        } else {
            onSelect(option, false, selectedPaymentMethod);
        }
    };
    /**
   * Function to return `card` if item is of type
   * debitCard or creditCard
   * otherwise return as it is
   * @param {*} item
   * @return {*} string
   */ var returnCardForCCAndDC = function(item) {
        if (item === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */ .Mf.DEBIT_CARD || item === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */ .Mf.CREDIT_CARD) {
            return _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.CARD */ .Mf.CARD;
        }
        return item;
    };
    var removePaytmFromMethods = function() {
        var methods = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], isObject = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        // removing paytm form react native webview environment as it is not working properly in webview
        var modes = methods || [];
        var indexOfPaytm = isObject ? modes.findIndex(function(ele) {
            return (ele === null || ele === void 0 ? void 0 : ele.payment_option_name) === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.PAYTM */ .Mf.PAYTM;
        }) : modes.indexOf(_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.PAYTM */ .Mf.PAYTM);
        if (indexOfPaytm > -1 && _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_WEBVIEW */ .x5) {
            modes.splice(indexOfPaytm, 1);
        }
        return modes;
    };
    /**
   * render component when mdr_flag is 1
   * @return {*}
   */ var renderPaymentOptionOnCustomerTransaction = function() {
        if ((0,_utils_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_11__/* .checkIfObjectExists */ .L)(paymentOptionsWithTxnCharge)) {
            var ref;
            var down_payment_modes = paymentOptionsWithTxnCharge.down_payment_modes, payment_modes = paymentOptionsWithTxnCharge.payment_modes;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        children: (ref = removePaytmFromMethods(payment_modes, true)) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                            if (!_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_4__/* .deviceWidth */ .o > 990 && item.payment_option_name !== _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.PAYTM */ .Mf.PAYTM) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                            else if (item === "whatsapp" && !_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && (0,_utils_operatingSystem__WEBPACK_IMPORTED_MODULE_5__/* .getMobileOperatingSystem */ .HG)() !== "Android") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                            else return item.payment_option_name !== _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.AMEX_CARD */ .Mf.AMEX_CARD && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                className: item.payment_option_name,
                                onClick: function() {
                                    return tapOptionForCustomerPayment(returnCardForCCAndDC(item.payment_option_name), item);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "logo-wrap",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (item === null || item === void 0 ? void 0 : item.payment_option_name) === "paytmupi" ? "https://cdn.dotpe.in/kiranaStatic/custom_website/paytmupilogo21august2023.png" : "//cdn.dotpe.in/cfe/image/".concat(returnCardForCCAndDC(item.payment_option_name), ".png"),
                                            alt: "logo"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: (0,_utils_getPaymentMethodName__WEBPACK_IMPORTED_MODULE_12__/* .getPaymentMethodName */ .d)(item.payment_option_name)
                                    }),
                                    !!item.transaction_charge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "transaction-charge-text",
                                        children: [
                                            item.transaction_charge,
                                            "% convenience fee"
                                        ]
                                    })
                                ]
                            });
                        })
                    }),
                    down_payment_modes && down_payment_modes.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "pt4 pb3 f7 fw6 black-70 lh-title",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "red",
                                        children: "Please Note:"
                                    }),
                                    " The Payment methods below have",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "red",
                                        children: "lower success rate"
                                    }),
                                    " at the moment"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                children: down_payment_modes === null || down_payment_modes === void 0 ? void 0 : down_payment_modes.map(function(item) {
                                    if (!_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_4__/* .deviceWidth */ .o > 990 && item !== "paytm") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                                    else if (item.payment_option_name === "whatsapp" && !_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && (0,_utils_operatingSystem__WEBPACK_IMPORTED_MODULE_5__/* .getMobileOperatingSystem */ .HG)() !== "Android") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                                    else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        className: item.payment_option_name,
                                        onClick: function() {
                                            item === "paytm" ? onSelect(item.payment_option_name, 2) : onSelect(item.payment_option_name, 1);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "logo-wrap",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: "//cdn.dotpe.in/cfe/image/".concat(item, ".png"),
                                                    alt: "logo"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: (0,_utils_getPaymentMethodName__WEBPACK_IMPORTED_MODULE_12__/* .getPaymentMethodName */ .d)(item.payment_option_name)
                                            })
                                        ]
                                    }, item.payment_option_name);
                                })
                            })
                        ]
                    })
                ]
            });
        }
        return null;
    };
    var renderPaymentOptionOnNormalTransaction = function() {
        var ref;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    children: (ref = removePaytmFromMethods(methods, false)) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                        if (!_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_4__/* .deviceWidth */ .o > 990 && item !== _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.PAYTM */ .Mf.PAYTM) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                        else if (item === "whatsapp" && !_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && (0,_utils_operatingSystem__WEBPACK_IMPORTED_MODULE_5__/* .getMobileOperatingSystem */ .HG)() !== "Android") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                        else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: item,
                            onClick: function() {
                                return onTapOption(item);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "logo-wrap",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: item === "paytmupi" ? "https://cdn.dotpe.in/kiranaStatic/custom_website/paytmupilogo21august2023.png" : "//cdn.dotpe.in/cfe/image/".concat(item, ".png"),
                                        alt: "logo"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: (0,_utils_getPaymentMethodName__WEBPACK_IMPORTED_MODULE_12__/* .getPaymentMethodName */ .d)(item)
                                })
                            ]
                        }, item);
                    })
                }),
                downPaymentMethods && downPaymentMethods.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "pt4 pb3 f7 fw6 black-70 lh-title",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "red",
                                    children: "Please Note:"
                                }),
                                " The Payment methods below have",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "red",
                                    children: "lower success rate"
                                }),
                                " at the moment"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            children: downPaymentMethods === null || downPaymentMethods === void 0 ? void 0 : downPaymentMethods.map(function(item) {
                                if (!_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_4__/* .deviceWidth */ .o > 990 && item !== "paytm") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                                else if (item === "whatsapp" && !_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && (0,_utils_operatingSystem__WEBPACK_IMPORTED_MODULE_5__/* .getMobileOperatingSystem */ .HG)() !== "Android") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                                else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    className: item,
                                    onClick: function() {
                                        item === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.PAYTM */ .Mf.PAYTM ? onSelect(item, 2) : onSelect(item, 1);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "logo-wrap",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "//cdn.dotpe.in/cfe/image/".concat(item, ".png"),
                                                alt: "logo"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: (0,_utils_getPaymentMethodName__WEBPACK_IMPORTED_MODULE_12__/* .getPaymentMethodName */ .d)(item)
                                        })
                                    ]
                                }, item);
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "paymentOptions-wrapper " + (orderDetails.payment_status === 0 || orderDetails.payment_status === 3 ? "" : "disabled"),
        children: (store === null || store === void 0 ? void 0 : (ref = store.services) === null || ref === void 0 ? void 0 : ref.mdr_flag) ? renderPaymentOptionOnCustomerTransaction() : renderPaymentOptionOnNormalTransaction()
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PaymentOptionsGrid);


/***/ }),

/***/ 642490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ codMethodRender; }
/* harmony export */ });
/* harmony import */ var _checkIfObjectExists__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(631891);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);


/**
 * func to check for cod in payment method
 * @param {*} otherMethods
 * @param {*} paymentOptionsWithTxnCharge
 * @param {*} storeInfo
 * @return {*} array of cod method or empty array
 */ var codMethodRender = function(otherMethods, paymentOptionsWithTxnCharge, storeInfo) {
    var ref, ref1, ref2;
    var method = otherMethods;
    if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.mdr_flag) && (0,_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_1__/* .checkIfObjectExists */ .L)(paymentOptionsWithTxnCharge)) method = paymentOptionsWithTxnCharge === null || paymentOptionsWithTxnCharge === void 0 ? void 0 : (ref1 = paymentOptionsWithTxnCharge.others) === null || ref1 === void 0 ? void 0 : ref1.map(function(method) {
        if (method.hasOwnProperty("payment_option_name")) return method["payment_option_name"];
    });
    if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.payment_method) !== _constants__WEBPACK_IMPORTED_MODULE_0__/* .PREPAID_POSTPAID_METHODS.PREPAID */ .R9.PREPAID && (method === null || method === void 0 ? void 0 : method.length) && method.includes(_constants__WEBPACK_IMPORTED_MODULE_0__/* .PAYMENT_TYPE_CONSTANTS.COD */ .Mf.COD)) {
        return method;
    }
    return [];
};


/***/ }),

/***/ 494604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getPaymentMethodName; }
/* harmony export */ });
/**
 * Helper function which returns the
 * hardcoded string for the payment method
 * @param {string} method
 * @return {string}
 */ var getPaymentMethodName = function(method) {
    switch(method){
        case "googlepay":
            return "Google Pay";
        case "cod":
            return "Cash";
        case "phonepe":
        case "pswitch":
            return "PhonePe";
        case "payzapp":
            return "PayZapp";
        case "whatsapp":
            return "WhatsApp";
        case "paytm":
            return "Paytm";
        case "paytmupi":
            return "Paytm UPI";
        case "airtel":
            return "Airtel";
        case "creditCard":
            return "Credit Card";
        case "debitCard":
            return "Debit Card";
        case "cemi":
            return "EMI";
        case "dupi":
            return "dupi";
        case "mobikwik":
            return "MobiKwik";
        default:
            return method;
    }
};


/***/ }),

/***/ 666466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ isStoreServiceBased; }
/* harmony export */ });
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66871);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);


function isStoreServiceBased() {
    return (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_0__/* .getStoreType */ .K)() !== _constants__WEBPACK_IMPORTED_MODULE_1__/* .STORE_CUSTOMIZATION.ORDER_BASED */ .DO.ORDER_BASED;
}


/***/ })

}]);